// extracted by mini-css-extract-plugin
export var warrantyBullets = "ProductWarranty-module--warrantyBullets--a3ef0";